import React from 'react';
import {Card} from "antd";
import _ from "lodash";

export default ({children, title, sub, ...props}) => {
  if (_.isArray(sub))
    sub = sub.map(s => <div key={s}>{s}</div>);

  return <Card title={<Card.Meta title={title} description={sub} />} {...props}>
    {children}
  </Card>
}

